import { Choice } from '../models/choice';
import { PackageCodeEnum } from '../enum/package-code.enum';

export const packagingUnits: Choice[] = [
    { value: PackageCodeEnum.PALLET, label: 'Pallet' },
    { value: PackageCodeEnum.BOX, label: 'Box' },
    { value: PackageCodeEnum.CARTON, label: 'Carton' },
    { value: PackageCodeEnum.TUBE, label: 'Tube' },
    { value: PackageCodeEnum.CRATE, label: 'Crate' },
    { value: PackageCodeEnum.DRUM, label: 'Drum' },
    { value: PackageCodeEnum.ROLL, label: 'Roll' },
    { value: PackageCodeEnum.TOTES, label: 'Totes' },
    { value: PackageCodeEnum.UNITS, label: 'Units' }
];
